import { useQuery } from "@tanstack/react-query";
import {
  getReferralsBankAcounts,
  getReferralsHistory,
  getReferralsStatus,
} from "./services";

export const useReferralsStatusQuery = () =>
  useQuery({
    queryKey: ["referrals", "status"],
    queryFn: getReferralsStatus,
    staleTime: Infinity,
  });

export const useReferralsHistoryQuery = () =>
  useQuery({
    queryKey: ["referrals", "history"],
    queryFn: getReferralsHistory,
    staleTime: Infinity,
  });

export const useReferralsBankAccounts = () =>
  useQuery({
    queryKey: ["referrals", "bankAccounts"],
    queryFn: getReferralsBankAcounts,
    staleTime: Infinity,
  });
